import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { powerBI } from '@modules/power-bi/constants/URL'
class APIPowerBIDashboard extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  async carregar(forceUpdate = false) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['power-bi/dashboardLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['power-bi/dashboard']
      }
    }

    if (store.getters['power-bi/dashboardLoading']) {
      return store.getters['power-bi/dashboard']
    }

    store.dispatch('power-bi/setDashboardLoading', true)

    this.reqCarregar = con.get(powerBI.list)
    const r = await this.reqCarregar

    if (r && r.status === 200) {
      store.dispatch('power-bi/setDashboard', r.value || [])
    } else {
      store.dispatch('power-bi/setDashboard', [])
    }

    store.dispatch('power-bi/setDashboardLoading', false)

    this.reqCarregar = null

    return r || {}
  }
}

const apiPowerBIDashboard = new APIPowerBIDashboard()
export { apiPowerBIDashboard }
